// extracted by mini-css-extract-plugin
export default {"form":"NewPasswordForm_form__nNtpE","btn":"NewPasswordForm_btn__gbgnS"};